import { useState } from 'react';
import { About, Disclaimer, Menu } from '@annea/ui';

type StandardMenuProps = {
  aboutTitle?: string;
  feedbackEmail?: string;
};

export default function StandardMenu({
  aboutTitle = 'Annea Apps Portal',
  feedbackEmail = import.meta.env.VITE_FEEDBACK_EMAIL || 'products@annea.sk',
}: StandardMenuProps) {
  const [aboutOpen, setAboutOpen] = useState(false);
  const [disclaimerOpen, setDisclaimerOpen] = useState(false);

  return (
    <>
      <Menu
        onShowDisclaimer={() => setDisclaimerOpen(true)}
        onShowAbout={() => setAboutOpen(true)}
        onShowChangelog={() => undefined}
        showChangelog={false}
        feedbackEmail={feedbackEmail}
        appName={aboutTitle}
      />

      {aboutOpen && (
        <About title={aboutTitle} onClose={() => setAboutOpen(false)}>
          <p>
            The Annea Apps Portal provides access to Annea tools, subscriptions,
            and organization management in one place.
          </p>
          <p>
            Use the App Catalog to discover tools, manage personal and organization
            subscriptions, and launch apps directly.
          </p>
          <p>
            <strong>Contact:</strong>{' '}
            <a href={`mailto:${feedbackEmail}`}>{feedbackEmail}</a>
          </p>
        </About>
      )}

      {disclaimerOpen && (
        <Disclaimer
          onAccept={() => setDisclaimerOpen(false)}
          onDecline={null}
          showDeclineButton={false}
        />
      )}
    </>
  );
}
